import type { HiddenContentItemConfig } from '@nodeTypeConfig/configTypes';

/**
 * this type is to prevent crashes when the node type is unknown or the node simply doesn't exist (anymore)
 */
const UNKNOWN_TYPE: HiddenContentItemConfig = {
  information: {
    single: 'Onbekend type node',
    plural: 'Onbekend type nodes',
  },
  hideInDocument: true,
  hideChildrenInDocument: true,
};

export default UNKNOWN_TYPE;
